import { handleViewImage } from "../../Utils/Utils";
import styles from "../dashboard/Dispatch.module.css";

const Slider = ({ data = [], mode, type = "image" }) => {
  if (data.length === 0) {
    return null;
  } else {
    return (
      <div
        className={`${styles.slider_track}  ${
          mode ? styles.slider_track_dark : {}
        }`}
      >
        {data.map((d, i) => (
          <div key={i} className={styles.slider_item}>
            <p style={{ color: mode && "#FFFFFF" }}>{d.header}</p>
            <div
              className={styles.image_view}
              onClick={() => handleViewImage(d.uri)}
              style={{ borderColor: mode && "#7a7b7d" }}
            >
              {type === "image" ? (
                <>
                  <img
                    src={
                      d.uri instanceof File
                        ? URL.createObjectURL(d.uri)
                        : `${process.env.REACT_APP_S3URL}${d.uri}`
                    }
                    alt={d.uri}
                    className={styles.file_preview}
                    loading="lazy"
                    style={{ color: mode && "#FFFFFF" }}
                  />
                </>
              ) : (
                <>
                  <video
                    className={styles.file_preview}
                    controls
                    muted
                    preload="metadata"
                    controlsList="nodownload"
                    style={{ backgroundColor: mode && "#1B1D21" }}
                  >
                    <source
                      src={
                        d.uri instanceof File
                          ? URL.createObjectURL(d.uri)
                          : `${process.env.REACT_APP_S3URL}${d.uri}`
                      }
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
};

export default Slider;
